export const STRATEGY_DOT_COLORS = [
  'bg-orange-500',
  'bg-teal-500',
  'bg-purple-500',
  'bg-sky-500',
  'bg-pink-500',
];

export const MAX_VISIBLE_DOTS = 3;
